<template>
    <div @click="showSheetData = true" v-if="options?.directMode !== true && options?.button !== false">
        <slot>Create a Text for the button</slot>
    </div>
    <Transition>
        <div v-show="showSheet" class="wrapper">
            <div class="overlay" @click.self="hide()"></div>
            <div class="modal-container" v-bind="$attrs">
                <div class="handle-sheet" @click="hide()"></div>
                <div class="close-sheet" @click="hide()">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="#1C1C1E" xmlns="http://www.w3.org/2000/svg" style="filter: invert(1);">
                        <path d="M7.18849 19.0508C6.81935 19.4199 6.80177 20.0791 7.19728 20.4658C7.58399 20.8525 8.24317 20.8438 8.61231 20.4746L13.9912 15.0869L19.3789 20.4746C19.7568 20.8525 20.4072 20.8525 20.794 20.4658C21.1719 20.0703 21.1807 19.4287 20.794 19.0508L15.415 13.6631L20.794 8.28419C21.1807 7.90626 21.1807 7.25587 20.794 6.86915C20.3984 6.49122 19.7568 6.48243 19.3789 6.86036L13.9912 12.2481L8.61231 6.86036C8.24317 6.49122 7.5752 6.47364 7.19728 6.86915C6.81056 7.25587 6.81935 7.91505 7.18849 8.28419L12.5762 13.6631L7.18849 19.0508Z"/>
                    </svg>
                </div>
                <div class="content-container">
                    <slot name="sheet">Add elements by using template v-slot:sheet</slot>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { computed, ref } from 'vue'

// eslint-disable-next-line
defineOptions({
    inheritAttrs: false
})
// eslint-disable-next-line
const props = defineProps({
    show: Boolean,
    options: Object
})
// eslint-disable-next-line
const emit = defineEmits(['close'])

const showSheetData = ref(false)

const showSheet = computed(() => {
    if(typeof props.show === 'boolean') return props.show
    else return showSheetData.value
})

const hide = () => {
    if(props.options.directMode === true) emit('close')
    if(typeof props.show === 'boolean') emit('close')
    showSheetData.value = false
}
</script>

<style scoped>
.wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
}
.modal-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    color: white;
    background-color: #1C1C1E;
    height: calc(100% - 20px);
    border-radius: 15px 15px 0 0;
}
.overlay {
    position: fixed;
    left: 0;
    top: -250px;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease-in-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
    transform: translateY(280px)
}
.handle-sheet {
    position: absolute;
    background-color: black;
    width: 50px;
    height: 4px;
    border-radius: 2px;
    top: 10px;
    left: calc(50% - 25px);
    cursor: pointer;
}
.dark .handle-sheet {
    background-color: white;
}
.close-sheet {
    position: absolute;
    background-color: rgba(255, 255, 255, 1);
    width: 25px;
    height: 25px;
    border-radius: 50%;
    top: 20px;
    right: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dark .close-sheet {
    background-color: rgba(255, 255, 255, 0.2);
}
.close-sheet > img {
    width: 20px;
    height: 20px;
}
.content-container {
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    flex: 1;
    height: calc(100% - 30px);
}
</style>
